class BannerSlider extends HTMLElement {
  constructor() {
    super();

    this.slider = this.querySelector('ul');
    this.sliderItems = this.querySelectorAll('li');
    this.totalPages = 1;

    if (!this.slider) return;

    const resizeObserver = new ResizeObserver(() => this.initPages());
    resizeObserver.observe(this.slider);

    setInterval(this.slideToNext.bind(this), 5000);
  }

  initPages() {
    const sliderItemsToShow = Array.from(this.sliderItems).filter(element => element.clientWidth > 0);
    this.sliderLastItem = sliderItemsToShow[sliderItemsToShow.length - 1];

    if (sliderItemsToShow.length === 0) return;

    this.slidesPerPage = Math.floor(this.slider.clientWidth / sliderItemsToShow[0].clientWidth);
    this.totalPages = sliderItemsToShow.length - this.slidesPerPage + 1;
  }

  slideToNext() {
    const currentPage = Math.round(this.slider.scrollLeft / this.sliderLastItem.clientWidth) + 1;
    const slideScrollPosition = currentPage === this.totalPages ? 0 : this.slider.scrollLeft + this.sliderLastItem.clientWidth;
    this.slider.scrollTo({ left: slideScrollPosition });
  }
}

customElements.define('banner-slider', BannerSlider);
